import React from 'react';

import PropTypes from 'prop-types';

import { useFeatureFlag } from 'wanderu-analytics';
import {
    FadeInOutContainer,
    FadeInOut,
} from 'wanderu-animations';
import { A } from 'wanderu-component-react-router-link';

import { changeTripButtonClicked } from '../events/SearchBannerEvents';

import styles from './BannerCardList.scss';

const propTypes = {
    searchBannerState: PropTypes.shape({
        complete: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string.isRequired,
            tripId: PropTypes.string.isRequired,
            tripSummary: PropTypes.bool.isRequired,
            url: PropTypes.string.isRequired,
        })),
        current: PropTypes.shape({
            date: PropTypes.string,
            text: PropTypes.string.isRequired,
        }),
        toDo: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string.isRequired,
        })),
    }).isRequired,
};

const defaultProps = {
    searchBannerState: PropTypes.shape({
        current: PropTypes.shape({
            date: '',
        }),
    }),
};

const BannerCard = (props) => {
    const {
        changeTripUrl,
        date,
        isComplete,
        isCurrent,
        text,
        tripId,
        tripSummary,
    } = props;

    const { isEnabled: isMultiDayVariant } = useFeatureFlag('multi-day-search');

    const onClick = () => {
        changeTripButtonClicked({
            tripId: tripId,
            tripSummary: tripSummary,
        });
    };

    return (
        <React.Fragment>
            {isComplete && (
                <li className={styles.completedText}>
                    <A
                        href={changeTripUrl}
                        onClick={onClick}
                        underline="none"
                    >
                        <button
                            alt={text}
                            className={styles.hoverButton}
                        >
                            {text}
                        </button>
                    </A>
                </li>
            )}
            {isCurrent && (
                <li className={styles.bannerContent}>
                    <span className={styles.bannerText}>
                        <h1 className={styles.current}>{text}</h1>

                        {(!isMultiDayVariant && date)
                        && <span className={styles.date}>{date}</span>}
                    </span>
                </li>
            )}
            {!isComplete && !isCurrent && (
                <li className={styles.toDoText}>{text}</li>
            )}
        </React.Fragment>
    );
};

BannerCard.propTypes = {
    changeTripUrl: PropTypes.string,
    date: PropTypes.string,
    isComplete: PropTypes.bool,
    isCurrent: PropTypes.bool,
    text: PropTypes.string.isRequired,
    tripId: PropTypes.string,
    tripSummary: PropTypes.bool,
};

const BannerCardList = (props) => {
    const {
        toDo,
        complete,
        current,
    } = props.searchBannerState;

    return (
        <React.Fragment>
            <FadeInOutContainer
                animateHeight={false}
                className={styles.fadeInOut}
            >
                <FadeInOut
                    className={styles.fadeInOut}
                    key={toDo.reduce((id, cards) => id + cards.text, '')}
                    unmountOnExit
                >
                    <ol className={styles.completed}>
                        {complete.map((card) => {
                            const {
                                text, url, tripId, tripSummary,
                            } = card;
                            return (
                                <BannerCard
                                    changeTripUrl={url}
                                    key={text}
                                    text={text}
                                    tripId={tripId}
                                    tripSummary={tripSummary}
                                    isComplete
                                />
                            );
                        })}
                        <BannerCard
                            date={current.date}
                            text={current.text}
                            isCurrent
                        />
                    </ol>
                    <ol className={styles.toDoSteps}>
                        {toDo.map((card) => {
                            const { text } = card;
                            return (
                                <BannerCard
                                    key={text}
                                    text={text}
                                />
                            );
                        })}
                    </ol>
                </FadeInOut>
            </FadeInOutContainer>
        </React.Fragment>
    );
};

BannerCardList.propTypes = propTypes;
BannerCardList.defaultProps = defaultProps;

export default BannerCardList;
